export enum GlobalAssetTableEvents {
    ClickProtocolLink = "Global Asset Table - Click Protocol Link",
    ClickAssetClassLink = "Global Asset Table - Click Asset Class Link",
    ClickNetworkLink = "Global Asset Table - Click Network Link",
    ClickAssetLink = "Global Asset Table - Click Asset Link",
    ChangeDistribution = "Global Asset Table - Change Distribution",
}
